import { UseQueryModalReturn } from "../../types";
import { Dayjs } from "dayjs";
import dayjs from "dayjs";

interface UseDateTimeQueryModalParams<TOperator> {
  inputValue?: { single: Dayjs | null; range: [Dayjs, Dayjs] | null };
  previousValue?: string | string[] | null;
  selectedOperator: TOperator;
  initialOperator: TOperator;
  isValid?: boolean | null;
}

export function useDateTimeQueryModal<TOperator>({
  inputValue,
  previousValue,
  selectedOperator,
  initialOperator,
  isValid,
}: UseDateTimeQueryModalParams<TOperator>): UseQueryModalReturn {
  const isValueUnchanged = () => {
    if (!inputValue || !previousValue) return false;
    if (Array.isArray(previousValue) && inputValue.range) {
      return (
        inputValue.range.length === previousValue.length &&
        inputValue.range.every((date, index) => {
          const currentMoment = dayjs(date);
          const prevMoment = dayjs(previousValue[index]);
          return currentMoment.isSame(prevMoment);
        })
      );
    }
    if (!Array.isArray(previousValue) && inputValue.single) {
      const currentMoment = dayjs(inputValue.single);
      const prevMoment = dayjs(previousValue);
      return currentMoment.isSame(prevMoment);
    }
    return false;
  };

  const isSubmitDisabled =
    !selectedOperator ||
    !isValid ||
    (isValueUnchanged() && selectedOperator === initialOperator);

  return { isSubmitDisabled };
}
